export class ReportClass {
    constructor() {
        this.id = 0;
        this.uuid = "";
        this.duid = "";
        this.cuid = "";
        this.issue = "";
    }
}